import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetAllProducts(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetAllProductsAttempt', handleGetAllProducts, api);
}

function* handleGetAllProducts(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getAllProducts], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetAllProductsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetAllProductsSuccess(response.data));
    }
}
